/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-radiation-beam-param.reducer';

export const TreatmentRadiationBeamParamDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRadiationBeamParamEntity = useAppSelector(state => state.treatmentRadiationBeamParam.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRadiationBeamParamDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.detail.title">TreatmentRadiationBeamParam</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.id}</dd>
          <dt>
            <span id="administeredValue">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.administeredValue">Administered Value</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.administeredValue}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.radiationSession ? treatmentRadiationBeamParamEntity.radiationSession.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.treatmentBeamParam">Treatment Beam Param</Translate>
          </dt>
          <dd>{treatmentRadiationBeamParamEntity.treatmentBeamParam ? treatmentRadiationBeamParamEntity.treatmentBeamParam.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-radiation-beam-param" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-radiation-beam-param/${treatmentRadiationBeamParamEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRadiationBeamParamDetail;
